module.exports = __webpack_public_path__ + "img/Ai.32a26f56.svg";